import { makeVar } from '@apollo/client';

export default makeVar({
  accessToken: localStorage.getItem(import.meta.env.VITE_ACCESS_TOKEN_KEY),
  refreshToken: localStorage.getItem(import.meta.env.VITE_REFRESH_TOKEN_KEY),
  ttl: null,
  refreshWithin: null,
  hasSubscription: false,
});
